import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export async function fetchMe() {
    try {
        const { data } = await api.get("/auth/me");
        return data;
    } catch {
        return null;
    }
}

export async function loginRedirect() {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export async function processSessionId(sessionId) {
    const { data } = await api.post("/auth/session", { session_id: sessionId });
    return data;
}

export async function logout() {
    try {
        await api.post("/auth/logout");
    } catch (e) {
        if (process.env.NODE_ENV !== "production") {
            // eslint-disable-next-line no-console
            console.warn("Logout API failed (session may already be invalid)", e);
        }
    }
}
